import ContentWrapper from 'components/ContentWrapper';
import { Button, TextField, Typography, Divider } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { paintCodeOptions, colourOptions } from 'constants/finishing';
import NumberFormat from 'components/NumberFormat';
import Row from './Row';
import { groupLineItems } from './lineItemGroups';
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { useStyles } from '../../styles';


export const FanComps = ({control, totalPrice, setTotalPrice}) => {

    const classes = useStyles();

    const { fields, append, remove } = useFieldArray({
        control,
        name: "lineItems"
        });

    const { included, options } = groupLineItems(fields);
    const optionsTotal = options.reduce((sum, { index }) => sum + (totalPrice[index] || 0), 0);

    return (
        <>
            <ContentWrapper>
                <Typography variant="h4" gutterBottom>
                    Model/Duty
                </Typography>
                <br />

                <SelectWithDataReactHook
                    name='attributes.designation'
                    type='text'
                    control={control}
                    label='Designation'
                    options={[
                        {
                            label: 'Centrifugal Fan',
                            id: 'Centrifugal Fan'
                        },
                        {
                            label: 'Material Handling Fan',
                            id: 'Material Handling Fan'
                        },
                        {
                            label: 'Dust Fan',
                            id: 'Dust Fan'
                        },
                        {
                            label: 'Axial Flow Fan',
                            id: 'Axial Flow Fan'
                        },
                        {
                            label: 'Side Channel Blower',
                            id: 'Side Channel Blower'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                /> 
                
                <Divider />
                <br />

                <ReactHookTextField
                    name='attributes.fanHanding'
                    type='text'
                    control={control}
                    label={`Handing`}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.fanOrt'
                    type='text'
                    control={control}
                    label={`Orientation`}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.FanPercentageWidth'
                    type='text'
                    control={control}
                    label={`% Width`}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.fanWidth'
                    type='text'
                    control={control}
                    label='Fan Width'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.fanDutyDensity'
                    type='text'
                    control={control}
                    label='Duty Density'
                    style={{width: '19%', marginRight: '1%'}}
                />
                
                <Divider />
                <br />

                <ReactHookTextField
                    name='attributes.fanVolume'
                    type='text'
                    control={control}
                    label={`Volume`}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.fanVolumeLabel'
                    type='text'
                    control={control}
                    label={`Volume Unit`}
                    options={[
                        {
                            label: 'CFM',
                            id: 'CFM'
                        },
                        {
                            label: 'M3/HR',
                            id: 'M3/HR'
                        },
                        {
                            label: 'M3/MIN',
                            id: 'M3/MIN'
                        },
                        {
                            label: 'M3/SEC',
                            id: 'M3/SEC'
                        },
                        {
                            label: 'L/S',
                            id: 'L/S'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanInletPressure'
                    type='text'
                    control={control}
                    label={`Inlet Pressure`}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDischargePressure'
                    type='text'
                    control={control}
                    label={`Discharge Pressure`}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.fanPressureLabel'
                    type='text'
                    control={control}
                    label={`Pressure Unit`}
                    options={[
                        {
                            label: 'IN WG',
                            id: 'IN WG'
                        },
                        {
                            label: 'MM W.G.',
                            id: 'MM W.G.'
                        },
                        {
                            label: 'KPA',
                            id: 'KPA'
                        },
                        {
                            label: 'PA',
                            id: 'PA'
                        },
                        {
                            label: 'MBAR',
                            id: 'MBAR'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanRpm'
                    type='text'
                    control={control}
                    label='RPM'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDesignTempC'
                    type='text'
                    control={control}
                    label='Design Temp (C)'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDutyKW'
                    type='text'
                    control={control}
                    label='Duty kW'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <Divider />
                <br />
                
                <ReactHookTextField
                    name='attributes.fanQty'
                    type='text'
                    control={control}
                    label='Qty'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDesign'
                    type='text'
                    control={control}
                    label='Design'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanSize'
                    type='text'
                    control={control}
                    label='Size'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.impellerDiameter'
                    type='text'
                    control={control}
                    label='Impeller Dia. mm'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <SelectWithDataReactHook
                    name='attributes.fanDrive'
                    control={control}
                    label='Drive'
                    options={[
                        {
                            label: 'Belt',
                            id: 'Belt'
                        },
                        {
                            label: 'Direct',
                            id: 'Direct'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />         
                <SelectWithDataReactHook
                    name='attributes.fanArrangement'
                    type='text'
                    control={control}
                    label='Arrangement'
                    creatable={true}
                    options={[
                        {
                            label: '1',
                            id: '1'
                        },
                        {
                            label: '2',
                            id: '2'
                        },
                        {
                            label: '4',
                            id: '4'
                        },
                        {
                            label: '4F',
                            id: '4F'
                        },
                        {
                            label: '9',
                            id: '9'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />         
                <SelectWithDataReactHook
                    name='attributes.fanIdRating'
                    type='text'
                    control={control}
                    label='ID Rating'
                    creatable={true}
                    options={[
                        {
                            label: 'ID1',
                            id: 'ID1'
                        },
                        {
                            label: 'ID2',
                            id: 'ID2'
                        },
                        {
                            label: 'ID3',
                            id: 'ID3'
                        },
                        {
                            label: 'ID4',
                            id: 'ID4'
                        },
                        {
                            label: 'ID5',
                            id: 'ID5'
                        },
                        {
                            label: 'ID6',
                            id: 'ID6'
                        },
                        {
                            label: 'ID7',
                            id: 'ID7'
                        },
                        {
                            label: 'ID8',
                            id: 'ID8'
                        },
                        {
                            label: 'ID9',
                            id: 'ID9'
                        },
                        {
                            label: 'ID10',
                            id: 'ID10'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.impellerType'
                    type='text'
                    control={control}
                    label='Type'
                    options={[
                        {
                            label: 'Backward Inclined',
                            id: 'Backward Inclined'
                        },
                        {
                            label: 'Laminar',
                            id: 'Laminar'
                        },
                        {
                            label: 'Axial',
                            id: 'Axial'
                        },
                        {
                            label: 'Aerofoil',
                            id: 'Aerofoil'
                        },
                        {
                            label: 'Radial',
                            id: 'Radial'
                        },
                        {
                            label: 'Radial Tip',
                            id: 'Radial Tip'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />          
                <br />
                <ReactHookTextField
                    name='attributes.fanOther'
                    type='text'
                    control={control}
                    label='Items Included In Price'
                    InputProps={{
                        multiline:true
                    }}
                    style={{width: '39%', marginRight: '1%'}}
                />

                { !!included.length && <>
                    <br />
                    <br />
                    <Typography variant="h5" gutterBottom>
                        Included from Aura
                    </Typography>
                    {included.map(({ item, index }) => (
                        <Row key={item.id} editable={false} control={control} index={index} fieldData={item} />
                    ))}
                </>}

                <br />
                <br />
                <Divider />
                <br />

                <Typography variant="h4" gutterBottom>
                    Motor
                </Typography>
                <br />

                <ReactHookTextField
                    name='attributes.motorMake'
                    type='text'
                    control={control}
                    label='Make'
                    style={{width: '19%', marginRight: '1%'}}
                />  

                <ReactHookTextField
                    name='attributes.motorFrame'
                    type='text'
                    control={control}
                    label='Frame'
                    style={{width: '19%', marginRight: '1%'}}
                />  

                <ReactHookTextField
                    name='attributes.motorTerminalBox'
                    type='text'
                    control={control}
                    label='TerminalBox'
                    style={{width: '19%', marginRight: '1%'}}
                />  

                <ReactHookTextField
                    name='attributes.motorKW'
                    type='text'
                    control={control}
                    label='kW'
                    style={{width: '19%', marginRight: '1%'}}
                />    
                <ReactHookTextField
                    name='attributes.motorSpeed'
                    type='text'
                    control={control}
                    label='Speed'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.motorPowerSupply'
                    type='text'
                    control={control}
                    label='Power Supply'
                    creatable={true}
                    options={[
                        {
                            label: '415V/3PH/50HZ',
                            id: '415V/3PH/50HZ'
                        },
                        {
                            label: '240V/1PH/50HZ',
                            id: '240V/1PH/50HZ'
                        },
                        {
                            label: '380V/1PH/50HZ',
                            id: '380V/1PH/50HZ'
                        },
                        {
                            label: '480V/1PH/50HZ',
                            id: '480V/1PH/50HZ'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />                    
                <SelectWithDataReactHook
                    name='attributes.motorProtection'
                    type='text'
                    control={control}
                    label='Protection'
                    creatable={true}
                    options={[
                        {
                            label: 'TEFC - IP55',
                            id: 'TEFC - IP55'
                        },
                        {
                            label: 'D.I.P',
                            id: 'D.I.P'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.motorPole'
                    type='text'
                    control={control}
                    label='Pole'
                    options={[
                        {
                            label: '2',
                            id: '2'
                        },
                        {
                            label: '4',
                            id: '4'
                        },
                        {
                            label: '6',
                            id: '6'
                        },
                        {
                            label: '8',
                            id: '8'
                        },
                        {
                            label: '10',
                            id: '10'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.motorDesign'
                    type='text'
                    control={control}
                    label='Design'
                    creatable={true}
                    options={[
                        {
                            label: 'Ex e, Class 1, Zone 1',
                            id: 'Ex e, Class 1, Zone 1'
                        },
                        {
                            label: 'Ex d Flameproof',
                            id: 'Ex d Flameproof'
                        },
                        {
                            label: 'Thermistors',
                            id: 'Thermistors'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                            
                <ReactHookTextField
                    name='attributes.motorOther'
                    type='text'
                    control={control}
                    label='Other'
                    InputProps={{
                        multiline:true
                    }}
                    style={{width: '39%', marginRight: '1%'}}
                />
            
                <br />
                <br />
                <Divider />
                <br />

                <Typography variant="h4" gutterBottom>
                    Finishing
                </Typography>
                <br />

                <SelectWithDataReactHook
                    name='attributes.internalCoatingType'
                    type='text'
                    control={control}
                    label='Internal'
                    creatable={true}
                    options={paintCodeOptions}
                    style={{width: '39%', marginRight: '1%'}}
                />    
                <SelectWithDataReactHook
                    name='attributes.externalCoatingType'
                    type='text'
                    control={control}
                    label='External'
                    creatable={true}
                    options={paintCodeOptions}
                    style={{width: '39%', marginRight: '1%'}}
                />  
                <SelectWithDataReactHook
                    name='attributes.externalCoatingColour'
                    control={control}
                    label='Colour'
                    creatable={true}
                    options={colourOptions}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <br />
                <br />
                <Divider />
                <br />

                <Typography variant="h4" gutterBottom>
                    Commercials
                </Typography>
                <br />

                <ReactHookTextField
                    name='attributes.fanEstimatedCost'
                    type='text'
                    control={control}
                    label='Fan Estimated Cost'
                    style={{width: '19%', marginRight: '1%'}}
                    InputProps={{
                        inputComponent: NumberFormat,
                    }}
                />

                <ReactHookTextField
                    name='attributes.fanSellPrice'
                    type='text'
                    control={control}
                    label='Fan Sell Price'
                    style={{width: '19%', marginRight: '1%'}}
                    InputProps={{
                        inputComponent: NumberFormat,
                    }}
                />
            </ContentWrapper>

             <ContentWrapper>
                <Typography variant="h4" gutterBottom>
                    Other Options
                </Typography>
                <br />



                { !options.length ?
                    <Button
                        variant='contained'
                        color='primary'
                        type="button"
                        onClick={() => append({ isOptional: true })}
                    >
                        Add an Option
                    </Button> :
                    <>
                        {options.map(({ item, index }) => (
                            <Row key={item.id} editable={true} control={control} index={index} fieldData={item} setTotalPrice={setTotalPrice} totalPrice={totalPrice} append={append} remove={remove} />
                        ))}
                    </>
                }

                <br />
                <br />
                <Divider />
                <br />
                <div style={{display: 'flex'}}>
                    <TextField
                        label='Total Price'
                        type='text'
                        disabled={true}
                        className={classes.disabledInput}
                        variant='outlined' 
                        InputLabelProps={{ shrink: true }} 
                        size='small'
                        value={optionsTotal}
                        style={{width: '215px', marginLeft: 'auto'}}
                        InputProps={{
                            inputComponent: NumberFormat,
                        }}
                    />
                </div>
            </ContentWrapper>
        </>
    );
};